import { DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { GldataService } from './misc/gldata-transfer/gldata.service';
import { AddressService } from './shared/address-edit-dialog/address.service';
import { BadDataService } from './shared/bad-data-ticket/bad-data.service';
import { BrokerCommissionService } from './shared/broker-commission/broker-commission.service';
import { ContactPickerService } from './shared/contact-picker/contact-picker.service';
import { ContactService } from './shared/contact-picker/contact.service';
import { InputHelperService } from './shared/input-helper.service';
import { ListGroupSortPipe } from './shared/list-control-group-sort/list-group-sort.pipe';
import { SaveService } from './shared/save.service';
import { SwotService } from './shared/swot-edit/swot.service';
import { GoalPipePipe } from './user/user-detail/goal-pipe.pipe';
import { UserListFilterPipe } from './user/user-list/user-list-filter.pipe';

@NgModule({
  // Preserve the ambient UserModule/SharedModule providers without their UI or feature routes.
  providers: [
    SaveService,
    BrokerCommissionService,
    ContactPickerService,
    ContactService,
    DatePipe,
    DecimalPipe,
    InputHelperService,
    ListGroupSortPipe,
    BadDataService,
    AddressService,
    SwotService,
    UserListFilterPipe,
    GoalPipePipe,
    GldataService
  ]
})
export class StartupFeatureProvidersModule {}
